import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

const PARSE_APP_ID = 'unAFkcaNDeXajurGB7LChj8SgQYS2ptm'
const URL_CDN = 'https://qd28tcd6b5.execute-api.sa-east-1.amazonaws.com/prod';
const URL_GERAL = 'https://portal-corona-api.saude.gov.br';
@Injectable()
export class PortalService {

  constructor(
    private http: HttpClient,
  ) { }

  getCDN(type): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/' + type),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response.results);
        });
    });
  }

  getGeral(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalGeralApi'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getSintese(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalSintese'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getSinteseSep(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalSinteseSep'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getSinteseSepParam(params): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalSinteseSepUf' + params),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getCasos(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalCasos'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          console.log('data', response);

          response.dias.splice(0, 2);
          response.semana.splice(0, 2);

          resolve(response);
        });
    });
  }

  getEstado(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalEstado'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getEstadoRegiao(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalEstadoRegiao'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getMunicipio(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalMunicipio'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getRegiao(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalRegiaoUf'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  getRegiaoSaude(): Promise<any> {
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      //apiHeader = apiHeader.append('X-Parse-Application-Id', PARSE_APP_ID);
      this.http.get(encodeURI(URL_CDN + '/PortalRegiaoSaude'),
        { headers: apiHeader, withCredentials: false }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }

  postInsumosCDN(type): Promise<any> {
    let params = {
      "size": 30,
      "sort": [
        "no_uf"
      ],
      "aggs": {
        "doses_distribuidas": {
          "sum": {
            "field": "doses_distribuidas"
          }
        },
        "luava_proc_n_cirurgico": {
          "sum": {
            "field": "luava_proc_n_cirurgico"
          }
        },
        "avental": {
          "sum": {
            "field": "avental"
          }
        },
        "leitos_alocados": {
          "sum": {
            "field": "leitos_alocados"
          }
        },
        "teste_rapido": {
          "sum": {
            "field": "teste_rapido"
          }
        },
        "alcool_etilico100": {
          "sum": {
            "field": "alcool_etilico_100ml"
          }
        },
        "alcool_etilico500": {
          "sum": {
            "field": "alcool_etilico_500ml"
          }
        },
        "touca_hosp": {
          "sum": {
            "field": "touca_hosp"
          }
        },
        "sapatilha": {
          "sum": {
            "field": "sapatilha"
          }
        },
        "mascara_3_camadas": {
          "sum": {
            "field": "mascara_3_camadas"
          }
        },
        "oculos_protecao": {
          "sum": {
            "field": "oculos_protecao"
          }
        },
        "uti_adulto": {
          "sum": {
            "field": "uti_adulto"
          }
        },
        "pop_2019": {
          "sum": {
            "field": "pop_2019"
          }
        },
        "doses_aplicadas": {
          "sum": {
            "field": "doses_aplicadas"
          }
        }
      }
    }
    return new Promise<any>((resolve) => {
      let apiHeader = new HttpHeaders();
      apiHeader = apiHeader.append('Authorization', 'Basic cGFpbmVsLWluc3Vtb3M6SHlmZU1mVEFwbGk=');
      apiHeader = apiHeader.append('Content-Type', 'application/json');
      this.http.post(encodeURI(URL_CDN + '/' + type), params,
        { headers: apiHeader }).toPromise().then((response: any) => {
          resolve(response);
        });
    });
  }
}
